import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Typography,
    Switch,
    FormControlLabel,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    useTheme,
} from '@mui/material';
import {
    Code as CodeIcon,
    ViewList as ViewListIcon,
} from '@mui/icons-material';
import { AppDispatch, RootState } from '../../configureStore';
import { SET_SHOW_ONLY_IMPORTANT_FIELDS } from '../../redux/reducer/ui';

interface FormPanelHeaderProps {
    viewMode: 'form' | 'json';
    onViewModeChange: (_: React.MouseEvent<HTMLElement>, newMode: 'form' | 'json' | null) => void;
    isDeveloper: boolean;
}

const FormPanelHeader = ({
    viewMode,
    onViewModeChange,
    isDeveloper,
}: FormPanelHeaderProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const theme = useTheme();
    const showOnlyImportant = useSelector<RootState, boolean>(({ ui }) => ui.showOnlyImportantFields);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2,
                flexShrink: 0,
            }}
        >
            <Typography variant="h6">
                {viewMode === 'json' ? 'JSON View' : 'Form Data Entry'}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {isDeveloper && (
                    <ToggleButtonGroup
                        value={viewMode}
                        exclusive
                        onChange={onViewModeChange}
                        size="small"
                    >
                        <ToggleButton value="form">
                            <Tooltip title="Form View">
                                <ViewListIcon fontSize="small" />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value="json">
                            <Tooltip title="JSON View">
                                <CodeIcon fontSize="small" />
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                )}
                {viewMode === 'form' && (
                    <FormControlLabel
                        control={(
                            <Switch
                                checked={showOnlyImportant}
                                onChange={(e) => dispatch({
                                    type: SET_SHOW_ONLY_IMPORTANT_FIELDS,
                                    showOnlyImportant: e.target.checked,
                                })}
                                size="small"
                            />
                          )}
                        label={(
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box
                                    sx={{
                                        width: 12,
                                        height: 12,
                                        border: `2px solid ${theme.palette.mode === 'dark' ? '#ffb74d' : '#f57c00'}`,
                                        borderRadius: 0.5,
                                    }}
                                />
                                <Typography
                                    variant="caption"
                                    sx={{ color: theme.palette.text.secondary }}
                                >
                                    Show only important
                                </Typography>
                            </Box>
                          )}
                    />
                )}
            </Box>
        </Box>
    );
};

export default FormPanelHeader;
